/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import { CmpButtonCoach } from "../CmpButtonCoach";
import "./style.css";

export const CmpPrimarybutton = ({ state, className, text }) => {
  return (
    <div className={`cmp-primarybutton ${className}`}>
      <CmpButtonCoach
        className="cmp-button-coach-instance"
        divClassName="design-component-instance-node"
        property1="default"
        text={text}
      />
    </div>
  );
};

CmpPrimarybutton.propTypes = {
  state: PropTypes.oneOf(["default"]),
  text: PropTypes.string,
};
